import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';

export const KwTable = styled(Table)``;
